import React from "react";
import { getGeoInfo, userprofile } from "../../Model/Users"; //Include Home
import {
  CreateOrder,
  RzrpayCreateOrder,
  ccavenueprocessorder,
  Creategrace,
} from "../../Model/Subscription"; //Include Home
import { withRouter, VirsionCheck, branchIO } from "../../Helpers/Common"; //Include Home
import Parser from "html-react-parser";
import { UserchangeSendpin } from "../../Model/Users";
import { SVGIcons, ImgIcons, Appsflyer } from "../../Helpers/Common";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CurrencyData } from "../ExplorePlan/Currency_json";
import * as Consts from "../../Config/config.js";
import BarLoader from "react-spinners/BarLoader";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import axios from "axios";
var SVGIcon = "";
var ImageData = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));
class Makepayment extends React.Component {
  constructor(props) {
    var planprice;
    super(props);

    this.state = {
      planprice: false,
      fenable: true,
      isChecked: false,
      loader: false,
      ccavenue: false,
      country: "",
      subscriptionOrderValue: "",
      planID: "",
    };
    this.handleChecked = this.handleChecked.bind(this);
  }

  handleChecked(e) {
    this.setState({ isChecked: e.target.value, fenable: false });
  }
  loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }
  processpayment() {
    //Payment Initiated
    Appsflyer("subscription_initiated", {});
    var couponcode;
    var isrenew = false;
    var promo_discount_price;
    var paymentGatways = this.state.isChecked;
    var renewal_subscription = false;
    var plan_id = this.props.props.state.actualplan.id;
    if (this.props.props.state.discount) {
      promo_discount_price = this.props.props.state.discount.discounted_price;
      couponcode = this.props.props.state.couponcode;
      this.setState({
        planprice: this.props.props.state.discount.discounted_price,
      });
    }
    this.setState({ loader: true });

    var Postdata = {
      plan_id: plan_id,
      payment_gateway: paymentGatways,
      promo_discount_price: promo_discount_price,
      renewal_subscription: renewal_subscription,
      coupon_applied: couponcode,
      country: this.state.country,
    };

    if (
      (this.props.props.state.btntype == "Upgrade Now") |
      (this.props.props.state.btntype == "Renew Now")
    ) {
      Postdata.renewal_subscription = true;
      isrenew = true;
    }
    CreateOrder(Postdata).then((response) => {
      var ResponseCreate = JSON.parse(response.data);
      // return
      if (ResponseCreate.subscription_data) {
        //CreateGrace
        var GraceCreate = {
          order_id: ResponseCreate.subscription_data.order_id,
          plan_id: ResponseCreate.subscription_data.plan_id,
        };

        Creategrace(GraceCreate).then((graceresponse) => {
          // Appsflyer("Gracepack Created", GraceCreate);
          // branchIO("Gracepack Created", GraceCreate)
          //paymentGatways = "CCAvenue_card"
          // if (paymentGatways == "Paypal") {
          //   const res = this.loadScript(
          //     "https://www.paypal.com/sdk/js?client-id=AYRz0iZ5LtwuD8pI-0NZVe9Ne5KMufn5FT16lg63j-JdIpAYhFQ01QqvCSEKw0ANfIgtCUa8kDen4stJ&components=buttons"
          //   );
          //   if(!res){
          //   }else{
          //     window.paypal?.Buttons({
          //       style: {
          //         layout: 'vertical',
          //         color:  'blue',
          //         shape:  'rect',
          //         label:  'paypal'
          //       }
          //     }).render('#paypal-button-container');
          //   }
          //   return;
          // }
          if (
            paymentGatways == "Razorpay_UPI" ||
            paymentGatways == "Razorpay_Wallets" ||
            paymentGatways == "Razorpay_card" ||
            paymentGatways == "Razorpay_Netbanking"
          ) {
            const res = this.loadScript(
              "https://checkout.razorpay.com/v1/checkout.js"
            );
            if (!res) {
              alert("Razorpay SDK failed to load. Are you online?");
              return;
            }
            this.setState({
              subscriptionOrderValue:
                ResponseCreate.subscription_data.order_value * 100,
            });
            var userprofile = JSON.parse(this.state.ProfileData.data.message);
            var params = {
              receipt: ResponseCreate.subscription_data.order_id,
              amount: ResponseCreate.subscription_data.order_value * 100,
              currency: ResponseCreate.subscription_data.currency,
              method: paymentGatways,
              receipt: ResponseCreate.subscription_data.order_id,
              user_email: userprofile.user_data.user_email,
              user_mobile: userprofile.user_data.user_mobile,
            };

            RzrpayCreateOrder(params).then((respp) => {
              //UPI & Netbanking

              if (paymentGatways == "Razorpay_UPI") {
                var options = {
                  key: Consts.RAZORPAY_KEY, // Enter the Key ID generated from the Dashboard
                  amount: (
                    ResponseCreate.subscription_data.order_value * 100
                  ).toString(),
                  customer_id: respp.customer_id, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                  currency: ResponseCreate.subscription_data.currency,
                  name: "Docubay",
                  /*"recurring":1,*/
                  description: ResponseCreate.subscription_data.plan_name,
                  // image: window.location.origin + "/img/docu-bay-white.png",
                  image: "https://dbcms.docubay.com/media-upload/1708001592-docu-bay-white.png",
                  order_id: respp.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
                  callback_url:
                    window.location.origin +
                    "/backend/subscription/rzpay/callback?order_id=" +
                    ResponseCreate.subscription_data.order_id +
                    "&flag=" +
                    isrenew,
                  prefill: {
                    name: userprofile.user_data.name,
                    email: userprofile.user_data.user_email,
                    contact: userprofile.user_data.user_mobile,
                  },
                  notes: {
                    address:
                      "Ground Floor, Techweb Center, New Link Rd, Oshiwara, Jogeshwari West, Mumbai, Maharashtra 400102",
                  },
                  theme: {
                    color: "#0E0D0D",
                    /*backdrop_color: "#ffffff00",*/
                  },
                  reminder_enable: true,
                  config: {
                    display: {
                      blocks: {
                        banks: {
                          name: "Pay via UPI & Netbanking",
                          instruments: [
                            {
                              method: "upi",
                            },
                            {
                              method: "netbanking",
                            },
                          ],
                        },
                      },
                      sequence: ["block.banks"],
                      preferences: {
                        show_default_blocks: false,
                      },
                    },
                  },
                  modal: {
                    ondismiss: function () {
                      window.location.href =
                        "backend/subscription/rzpay/cancelpayment?order_id=" +
                        ResponseCreate.subscription_data.order_id;
                    },
                  },
                };
                const paymentObject = new window.Razorpay(options);
                this.setState({ loader: false });
                paymentObject.open();
              } else if (paymentGatways == "Razorpay_Wallets") {
                var options = {
                  key: Consts.RAZORPAY_KEY, // Enter the Key ID generated from the Dashboard
                  amount: ResponseCreate.subscription_data.order_value,
                  customer_id: respp.customer_id, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                  currency: ResponseCreate.subscription_data.currency,
                  name: ResponseCreate.subscription_data.plan_name,
                  /*"recurring":1,*/
                  description: ResponseCreate.subscription_data.plan_name,
                  image: "https://dbcms.docubay.com/media-upload/1708001592-docu-bay-white.png",
                  order_id: respp.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
                  callback_url:
                    window.location.origin +
                    "/backend/subscription/rzpay/callback?order_id=" +
                    ResponseCreate.subscription_data.order_id +
                    "&flag=" +
                    isrenew,
                  prefill: {
                    name: userprofile.user_data.name,
                    email: userprofile.user_data.user_email,
                    contact: userprofile.user_data.user_mobile,
                  },
                  notes: {
                    address:
                      "Ground Floor, Techweb Center, New Link Rd, Oshiwara, Jogeshwari West, Mumbai, Maharashtra 400102",
                  },
                  theme: {
                    color: "#0E0D0D",
                    /*backdrop_color: "#ffffff00",*/
                  },
                  reminder_enable: true,
                  config: {
                    display: {
                      blocks: {
                        banks: {
                          name: "Pay via Wallets",
                          instruments: [
                            {
                              method: "wallet",
                              wallets: [
                                "phonepe",
                                "freecharge",
                                "mobikwik",
                                "airtelmoney",
                                "paytm",
                                "amazonepay",
                                "jiomoney",
                                "olamoney",
                              ],
                            },
                          ],
                        },
                      },
                      sequence: ["block.banks"],
                      preferences: {
                        show_default_blocks: false,
                      },
                    },
                  },
                  modal: {
                    ondismiss: function () {
                      window.location.href =
                        "backend/subscription/rzpay/cancelpayment?order_id=" +
                        ResponseCreate.subscription_data.order_id;
                    },
                  },
                };
                this.setState({ loader: false });
                const paymentObject = new window.Razorpay(options);
                paymentObject.open();
                //Razorpay_Wallets
              } else if (paymentGatways == "Razorpay_card") {
                //Razorpay Cards
                var options = {
                  key: Consts.RAZORPAY_KEY, // Enter the Key ID generated from the Dashboard
                  amount: ResponseCreate.subscription_data.order_value,
                  customer_id: respp.customer_id, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                  currency: ResponseCreate.subscription_data.currency,
                  name: ResponseCreate.subscription_data.plan_name,
                  /*"recurring":1,*/
                  description: ResponseCreate.subscription_data.plan_name,
                  image: "https://dbcms.docubay.com/media-upload/1708001592-docu-bay-white.png",
                  order_id: respp.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
                  callback_url:
                    window.location.origin +
                    "/backend/subscription/rzpay/callback?order_id=" +
                    ResponseCreate.subscription_data.order_id +
                    "&flag=" +
                    isrenew,
                  prefill: {
                    name: userprofile.user_data.name,
                    email: userprofile.user_data.user_email,
                    contact: userprofile.user_data.user_mobile,
                  },
                  notes: {
                    address:
                      "Ground Floor, Techweb Center, New Link Rd, Oshiwara, Jogeshwari West, Mumbai, Maharashtra 400102",
                  },
                  theme: {
                    color: "#0E0D0D",
                    /*backdrop_color: "#ffffff00",*/
                  },
                  reminder_enable: true,
                  config: {
                    display: {
                      blocks: {
                        hdfc: {
                          //name for HDFC block
                          name: "Pay Using Card",
                          instruments: [
                            {
                              method: "card",
                            },
                          ],
                        },
                      },
                      hide: [
                        {
                          method: "upi",
                        },
                      ],
                      sequence: ["block.hdfc", "block.other"],
                      preferences: {
                        show_default_blocks: false, // Should Checkout show its default blocks?
                      },
                    },
                  },
                  modal: {
                    ondismiss: function () {
                      window.location.href =
                        "backend/subscription/rzpay/cancelpayment?order_id=" +
                        ResponseCreate.subscription_data.order_id;
                    },
                  },
                };
                const paymentObject = new window.Razorpay(options);
                this.setState({ loader: false });
                paymentObject.open();

                //Razorpay_Wallets
              } else if (paymentGatways == "Razorpay_Netbanking") {
                //Razorpay Cards
                var options = {
                  key: Consts.RAZORPAY_KEY, // Enter the Key ID generated from the Dashboard
                  amount: ResponseCreate.subscription_data.order_value,
                  customer_id: respp.customer_id, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                  currency: ResponseCreate.subscription_data.currency,
                  name: ResponseCreate.subscription_data.plan_name,
                  /*"recurring":1,*/
                  description: ResponseCreate.subscription_data.plan_name,
                  image: "https://dbcms.docubay.com/media-upload/1708001592-docu-bay-white.png",
                  order_id: respp.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
                  callback_url:
                    window.location.origin +
                    "/backend/subscription/rzpay/callback?order_id=" +
                    ResponseCreate.subscription_data.order_id +
                    "&flag=" +
                    isrenew,
                  prefill: {
                    name: userprofile.user_data.name,
                    email: userprofile.user_data.user_email,
                    contact: userprofile.user_data.user_mobile,
                  },
                  notes: {
                    address:
                      "Ground Floor, Techweb Center, New Link Rd, Oshiwara, Jogeshwari West, Mumbai, Maharashtra 400102",
                  },
                  theme: {
                    color: "#0E0D0D",
                    /*backdrop_color: "#ffffff00",*/
                  },
                  reminder_enable: true,
                  config: {
                    display: {
                      blocks: {
                        banks: {
                          name: "Pay Netbanking",
                          instruments: [
                            {
                              method: "netbanking",
                            },
                          ],
                        },
                      },
                      sequence: ["block.banks"],
                      preferences: {
                        show_default_blocks: false,
                      },
                    },
                  },
                  modal: {
                    ondismiss: function () {
                      window.location.href =
                        "backend/subscription/rzpay/cancelpayment?order_id=" +
                        ResponseCreate.subscription_data.order_id;
                    },
                  },
                };

                const paymentObject = new window.Razorpay(options);
                this.setState({ loader: false });
                paymentObject.open();
                //Razorpay_Wallets
              }
            });
          }
          else {
            if (paymentGatways == "CCAvenue_card") {
              var jsonreq = ResponseCreate.subscription_data;
              jsonreq.flag = isrenew;
              ccavenueprocessorder(JSON.stringify(jsonreq)).then(
                (ccavenueResponse) => {
                  if (ccavenueResponse) {
                    window.location.href = ccavenueResponse;
                  }
                }
              );
            }
          }
        });
      } else {
        window.location.href = "/";
      }
    });
  }
  handleSubmit(e) {
  }
  btndisable() {
  }
  componentDidMount() {
    this.setState({
      planID: this.props.props.state.actualplan.id
    })

    if (this.props.props.state) {
      if (this.props.props.state.discount) {
        this.setState({
          planprice: this.props.props.state.discount.discounted_price,
        });
      } else {
        this.setState({
          planprice: this.props.props.state.actualplan.actual_price,
        });
      }
    }


    getGeoInfo().then((res) => {
      this.setState({
        country: res,
      });
    });
    //Get Virsion Check Data
    VirsionCheck().then((vcheckres) => {
      let data = {
        seesionID: localStorage.getItem("session_id"),
        userID: localStorage.getItem("userID")
      }
      userprofile(data).then((userprofile) => {
        if (userprofile.data.success == false) {
          this.props.navigate("/createaccount");
        } else {
          this.setState({
            VirsionCheckData: vcheckres,
            VirsionCheckDataloaded: true,
            DataisLoaded: true,
            ProfileData: userprofile,
          });
        }
      });
    });
  }

  createOrder(data, actions) {

    return actions.order
      .create({
        purchase_units: [
          {
            // description: "Sunflower",
            amount: {
              currency_code: "USD",
              value: 1,
            },
          },
        ],
      })
      .then((orderID) => {
        return orderID;
      });
  }

  // check Approval
  onApprove(data, actions) {
    return actions.order.capture().then(function (details) {
      const { payer } = details;
      // setSuccess(true);
    });
  }

  //capture likely error
  onError(data, actions) {
    // setErrorMessage("An Error occured with your payment ");
  }

  render() {
    var currencyData = CurrencyData();
    var Pricecurr = this.props.props.state.actualplan.currency;
    var currency = currencyData[Pricecurr];

    // if (this.state.loader) {
    //   // return <div className="loader"></div>;
    //   return (
    //     <div className="loader">
    //       <BarLoader color="#ff000f" />
    //     </div>
    //   );
    // }
    if (this.props.props.state) {
      return (
        <div>
          <div className="temp4-container">
            <div className="temp4">
              <hr />
              <hr />
              <div className="temp4-InnerRound50">
                <div className="temp4-InnerRound1">
                  <div className="temp4-InnerRound2" />
                </div>
              </div>
              <div className="temp4-InnerRound51">
                <div className="temp4-InnerRound1">
                  <div className="temp4-InnerRound2" />
                </div>
              </div>
              <div className="temp4-InnerRound52">
                <div className="temp4-InnerRound1">
                  <div className="temp4-InnerRound2" />
                </div>
              </div>
            </div>
          </div>
          <header>
            <div className="mainNav pmenu">
              <a
                onClick={() => {
                  this.props.props.backbtn();
                }}
              >
                <div className="docubayBack white">
                  <img src={SVGIcon["back.svg"]} alt="DocuBay" /> Make Payment
                </div>
              </a>
            </div>
          </header>
          <main>
            {this.state.ccavenue.data ? Parser(this.state.ccavenue.data) : null}
            {document.redirect ? document.redirect.submit() : null}
            <section className="mb-0">
              <div className="temp58">
                <div className="temp58-inn">
                  <h3>
                    {this.props.props.state.actualplan.title.head}{" "}
                    {this.props.props.state.actualplan.title.title}
                  </h3>
                  <h2>
                    {currency}
                    {Math.trunc(this.state.planprice)} /-
                  </h2>
                  <h6>All Inclusive Billing Amount</h6>
                </div>
              </div>
            </section>
            <section className="mb-0">
              <div className="temp59">
                <div className="temp59-inn">
                  {currency == "₹" ? (
                    <>
                      <div className="temp59-area">
                        <div className="left-59">
                          <div className="img-area">
                            <img src={SVGIcon["net-banking.svg"]} />
                          </div>
                          <div className="text-59">Net Banking</div>
                        </div>
                        <div className="right-59">
                          <div className="price">
                            {currency}
                            {Math.trunc(this.state.planprice)}
                          </div>
                          <label className="temp59-radio">
                            <input
                              type="radio"
                              name="radio"
                              value="Razorpay_Netbanking"
                              onChange={(e) => {
                                this.handleChecked(e);
                              }}
                            />
                            <span className="checkmark" />
                          </label>
                        </div>
                      </div>
                      <div className="temp59-area">
                        <div className="left-59">
                          <div className="img-area">
                            <img src={SVGIcon["credit-card.svg"]} />
                          </div>
                          <div className="text-59">Credit / Debit Card</div>
                        </div>
                        <div className="right-59">
                          <div className="price">
                            {currency}
                            {Math.trunc(this.state.planprice)}
                          </div>
                          <label className="temp59-radio">
                            <input
                              type="radio"
                              name="radio"
                              value="Razorpay_card"
                              onChange={(e) => {
                                this.handleChecked(e);
                              }}
                            />
                            <span className="checkmark" />
                          </label>
                        </div>
                      </div>
                      <div className="temp59-area">
                        <div className="left-59">
                          <div className="img-area">
                            <img src={SVGIcon["upi.png"]} className="upi" />
                          </div>
                          <div className="text-59">UPI</div>
                        </div>
                        <div className="right-59">
                          <div className="price">
                            {currency}
                            {Math.trunc(this.state.planprice)}
                          </div>
                          <label className="temp59-radio">
                            <input
                              type="radio"
                              name="radio"
                              value="Razorpay_UPI"
                              onChange={(e) => {
                                this.handleChecked(e);
                              }}
                            />
                            <span className="checkmark" />
                          </label>
                        </div>
                      </div>
                      <div className="temp59-area">
                        <div className="left-59">
                          <div className="img-area">
                            <img src={SVGIcon["wallets.svg"]} />
                          </div>
                          <div className="text-59">Wallets</div>
                        </div>
                        <div className="right-59">
                          <div className="price">
                            {currency}
                            {Math.trunc(this.state.planprice)}
                          </div>
                          <label className="temp59-radio">
                            <input
                              type="radio"
                              name="radio"
                              value="Razorpay_Wallets"
                              onChange={(e) => {
                                this.handleChecked(e);
                              }}
                            />
                            <span className="checkmark" />
                          </label>
                        </div>
                      </div>
                      {/* <div className="temp59-area">
                        <div className="left-59">
                          <div className="img-area">
                            <img src={SVGIcon["wallets.svg"]} />
                          </div>
                          <div className="text-59" id="paypal-button-container">
                            <PayPalScriptProvider
                              options={{
                                "client-id":
                                  "AZ2Bgywf1975rHl7HVvP7FcmSoFSYYuMQ8HGryv4CaVnQ4kV2LOEdyw298xQox55gdUbXFq7GxaaaR3m",
                              }}
                            >
                              <div>
                                <PayPalButtons
                                  style={{ layout: "horizontal" }}
                                  createOrder={this.createOrder}
                                  onApprove={this.onApprove}
                                />
                              </div>
                            </PayPalScriptProvider>
                          </div>
                        </div>
                        <div className="right-59">
                          <div className="price">
                            {currency}
                            {this.state.planprice}
                          </div>
                          <label className="temp59-radio">
                            <input
                              type="radio"
                              name="radio"
                              value="Paypal"
                              onChange={(e) => {
                                this.handleChecked(e);
                              }}
                            />
                            <span className="checkmark" />
                          </label>
                        </div>
                      </div> */}

                      <div className="temp59-area" style={{ display: "none" }}>
                        <div className="left-59">
                          <div className="img-area">
                            <img src={SVGIcon["credit-card.svg"]} />
                          </div>
                          <div className="text-59">CC Avenue</div>
                        </div>
                        <div className="right-59">
                          <div className="price">
                            {currency}
                            {this.state.planprice}
                          </div>
                          <label className="temp59-radio">
                            <input
                              type="radio"
                              name="radio"
                              value="CCAvenue_card"
                              onChange={(e) => {
                                this.handleChecked(e);
                              }}
                            />
                            <span className="checkmark" />
                          </label>
                        </div>
                      </div>
                      {/*<div className="temp59-area">
                  <div className="left-59">
                    <div className="img-area"><img src={SVGIcon['amazon-pay.svg']} /></div>
                    <div className="text-59">Amazon Pay - <a href="#">Link Account </a> </div>
                  </div>
                  <div className="right-59">
                    <div className="price">{currency}{this.state.planprice}</div>
                    <label className="temp59-radio">
                      <input type="radio" name="radio" />
                      <span className="checkmark" />
                    </label>
                  </div>
                </div>*/}
                      {/*<div className="temp59-area">
                                              <div className="left-59">
                                                <div className="img-area">
                                                  <img src={SVGIcon["paytm.png"]} className="upi" />
                                                </div>
                                                <div className="text-59">Paytm </div>
                                              </div>
                                              <div className="right-59">
                                                <div className="price">
                                                  {currency}
                                                  {this.state.planprice}
                                                </div>
                                                <label className="temp59-radio">
                                                  <input
                                                    type="radio"
                                                    name="radio"
                                                    value="Paytm"
                                                    onChange={(e) => {
                                                      this.handleChecked(e);
                                                    }}
                                                  />
                                                  <span className="checkmark" />
                                                </label>
                                              </div>
                                            </div>*/}
                    </>
                  ) : null}
                  {currency == "$" ? (
                    <div className="temp59-area">
                      <div className="left-59">
                        <div className="img-area">
                          <img src={SVGIcon["credit-card.svg"]} />
                        </div>
                        <div className="text-59">Credit / Debit Card</div>
                      </div>
                      <div className="right-59">
                        <div className="price">
                          {currency}
                          {Math.trunc(this.state.planprice)}
                        </div>
                        <label className="temp59-radio">
                          <input
                            type="radio"
                            name="radio"
                            value="CCAvenue_card"
                            onChange={(e) => {
                              this.handleChecked(e);
                            }}
                          />
                          <span className="checkmark" />
                        </label>
                      </div>
                    </div>
                  ) : currency != "$" && currency != "₹" ? (
                    <div className="temp59-area">
                      <div className="left-59">
                        <div className="img-area">
                          <img src={SVGIcon["credit-card.svg"]} />
                        </div>
                        <div className="text-59">Credit / Debit Card</div>
                      </div>
                      <div className="right-59">
                        <div className="price">
                          {currency}
                          {Math.trunc(this.state.planprice)}
                        </div>
                        <label className="temp59-radio">
                          <input
                            type="radio"
                            name="radio"
                            value="CCAvenue_card"
                            onChange={(e) => {
                              this.handleChecked(e);
                            }}
                          />
                          <span className="checkmark" />
                        </label>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="temp59-btn">
                <button
                  type="submit"
                  id="sendEnquiryBtn"
                  disabled={this.state.fenable}
                  className={this.state.fenable ? "btn-black" : "btn-red"}
                  onClick={() => {
                    this.processpayment();
                  }}
                >
                  Make payment
                </button>
              </div>
            </section>
          </main>
        </div>
      );
    }
  }
}
export default withRouter(Makepayment);
